import { Box, Card, CardContent, Typography, Chip } from "@mui/material";
import { useTheme } from "../../../contexts/ThemeContext";

export const QuickActionCard = ({
	title,
	description,
	icon,
	color,
	onClick,
	banner = false,
	disabled = false
}) => {
	const { theme } = useTheme();

	return <>
		<Card
			sx={{
				cursor: !disabled && 'pointer',
				transition: 'all 0.3s ease',
				border: `1px solid ${banner ? color : theme.border.medium}`,
				height: "100%",
				borderRadius: '12px',
				background: theme.background.tertiary,
				position: 'relative',
				overflow: 'visible',
				'&:hover': {
					borderColor: color,
					transform: 'translateY(-4px)',
					boxShadow: theme.isDarkMode
						? `0 12px 40px rgba(74, 159, 234, 0.2)`
						: `0 12px 40px rgba(0,0,0,0.15)`,
					'& .action-icon': {
						transform: 'scale(1.1)',
						color: color,
						filter: banner
							? 'drop-shadow(0 0 8px rgba(249, 115, 22, 0.7))'
							: 'none'
					},
					'& .new-banner': {
						transform: 'scale(1.05)',
						boxShadow: theme.isDarkMode
							? '0 4px 12px rgba(249, 115, 22, 0.4)'
							: '0 4px 12px rgba(249, 115, 22, 0.3)'
					}
				}
			}}
			onClick={() => {
				if (disabled) return;
				onClick();
			}}
		>
			{banner && (
				<Chip
					label={disabled ? "COMING SOON" : "NEW"}
					className="new-banner"
					sx={{
						position: 'absolute',
						top: -8,
						right: 12,
						background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
						color: '#FFFFFF',
						fontWeight: 'bold',
						fontSize: '0.7rem',
						height: '20px',
						zIndex: 1,
						border: `2px solid ${theme.background.tertiary}`,
						transition: 'all 0.3s ease',
						animation: 'gentle-pulse 3s ease-in-out infinite',
						'@keyframes gentle-pulse': {
							'0%, 100%': {
								transform: 'scale(1)',
								filter: 'drop-shadow(0 0 4px rgba(249, 115, 22, 0.4))'
							},
							'50%': {
								transform: 'scale(1.02)',
								filter: 'drop-shadow(0 0 8px rgba(249, 115, 22, 0.6))'
							}
						},
						'& .MuiChip-label': {
							padding: '0 6px',
							letterSpacing: '0.5px'
						},
						fontFamily: theme.fontFamily
					}}
				/>
			)}

			{banner && (
				<Box
					sx={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						borderRadius: '12px',
						background: theme.isDarkMode
							? 'linear-gradient(135deg, rgba(249, 115, 22, 0.03) 0%, rgba(234, 88, 12, 0.02) 100%)'
							: 'linear-gradient(135deg, rgba(249, 115, 22, 0.02) 0%, rgba(234, 88, 12, 0.01) 100%)',
						pointerEvents: 'none',
						zIndex: 0
					}}
				/>
			)}

			<CardContent sx={{ textAlign: 'center', p: 3, position: 'relative', zIndex: 1 }}>
				<Box
					className="action-icon"
					sx={{
						color: color,
						mb: 2,
						display: 'flex',
						justifyContent: 'center',
						transition: 'all 0.3s ease',
						filter: banner
							? 'drop-shadow(0 0 4px rgba(249, 115, 22, 0.4))'
							: 'none'
					}}
				>
					{icon}
				</Box>
				<Typography variant="h6" sx={{
					fontFamily: theme.fontFamily,
					color: theme.text.primary,
					mb: 1,
					fontWeight: 'bold'
				}}>
					{title}
				</Typography>
				<Typography variant="body2" sx={{
					color: theme.text.secondary,
					fontFamily: theme.fontFamily,
					lineHeight: 1.5
				}}>
					{description}
				</Typography>
			</CardContent>
		</Card>
	</>
};